import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { initMonitoring } from './utils/monitoring';
import { isNative } from './native/platform';

// Sentry / GA4（環境変数未設定なら no-op）
initMonitoring();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// PWA: Service Worker を登録
// 本番環境でのみ有効化されます。ネイティブ(Capacitor)の WKWebView はカスタムスキームで動作し
// Service Worker 未対応のため登録しない（design.md §4.8）
if (!isNative()) {
  serviceWorkerRegistration.register({
    onSuccess: (registration) => {
      console.log('[PWA] Service Worker 登録成功！オフラインでも動作します。');
    },
    onUpdate: (registration) => {
      console.log('[PWA] 新しいバージョンが利用可能です。');
      // 新しいバージョンがある場合、ユーザーに通知することも可能
      if (window.confirm('新しいバージョンが利用可能です。更新しますか？')) {
        registration.waiting.postMessage({ type: 'SKIP_WAITING' });
        window.location.reload();
      }
    },
  });
}
